// extracted by mini-css-extract-plugin
export default {"modal-ask-why-select":"ModalAskWhy_modal-ask-why-select__3VYDU","modal-ask-why-questions":"ModalAskWhy_modal-ask-why-questions__wwx2P"};